export default __webpack_public_path__ + "static/media/qt-dropdown.0df59795.webp";